export const sourceOptions = {
  BOOKING_APP_MOBILE: 'booking_app_mobile',
  BOOKING_APP_DESKTOP: 'booking_app_desktop',
  CHAT_AI: 'chat_ai',
  VOICE_AI: 'voice_ai',
  PROTRACTOR: 'protractor',
  DEFAULT: 'default',
};

const sourceLabels = {
  [sourceOptions.BOOKING_APP_MOBILE]: 'Booking App Mobile',
  [sourceOptions.BOOKING_APP_DESKTOP]: 'Booking App Desktop',
  [sourceOptions.CHAT_AI]: 'Chat AI',
  [sourceOptions.VOICE_AI]: 'Voice AI',
  [sourceOptions.PROTRACTOR]: 'Protractor',
  [sourceOptions.DEFAULT]: '-',
};

export const getSourceLabel = source => {
  return sourceLabels[source] ?? sourceLabels[sourceOptions.DEFAULT];
};
